import InvoiceDetailsHeader from "./InvoiceDetailsHeader";
import InvoiceDetailsBody from "./InvoiceDetailsBody";
import styles from "../../styles/addInvoice.module.css";

export default function InvoiceDetails({
  invoiceData,
  updateField,
  errors = {},
  onIsAguaChange,
  isAgua,
}) {
  return (
    <div className={styles["invoice-details"]}>
      <InvoiceDetailsHeader />
      <InvoiceDetailsBody
        invoiceData={invoiceData}
        updateField={updateField}
        errors={errors}
        onIsAguaChange={onIsAguaChange}
        isAgua={isAgua}
      />
    </div>
  );
}
